import { render, staticRenderFns } from "./roleList.vue?vue&type=template&id=e9634b88&scoped=true"
import script from "./roleList.vue?vue&type=script&lang=js"
export * from "./roleList.vue?vue&type=script&lang=js"
import style0 from "./roleList.vue?vue&type=style&index=0&id=e9634b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9634b88",
  null
  
)

export default component.exports